import classNames from 'classnames';
import { ComponentProps, ReactNode } from 'react';
import { Card } from 'react-bootstrap';

import './style.scss';
import { FormattedMessage } from 'react-intl';

export function ChatCard({ className, ...props }: Omit<ComponentProps<'div'>, 'children'>) {
  return (
    <Card
      className={classNames('quick-start-card border border-opacity-40 bg-transparent overflow-hidden', className)}
      {...props}
    >
      <Card.Header className="p-3">
        <Card.Title as="h5">
          <FormattedMessage
            id="smartQuote.quickStart.card3.title"
            defaultMessage="Get quotes directly in chat conversation"
          />
        </Card.Title>
      </Card.Header>
      <Card.Body className="flex-y gap-4 p-4 pt-0">
        <ChatBull align="right">
          <i aria-hidden="true" className="icon icon-outlined fs-2 lh-1">
            email
          </i>
          Pricing request.msg
        </ChatBull>
        <ChatBull>5.1234 %</ChatBull>
      </Card.Body>
    </Card>
  );
}

function ChatBull({ children, align = 'left' }: { children: ReactNode; align?: 'left' | 'right' }) {
  return <div className={`chat-bull ${align} flex-x gap-2`}>{children}</div>;
}
